import { createIconDefinition } from '../../../../cross-team-shared/icons/create-icon-definition';

export const translateModeIcon = createIconDefinition(
  'translateMode',
  `<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19.9993 28.3337L16.4577 24.792L17.6452 23.6045L19.166 25.1253V20.8337H14.8952L16.416 22.3337L15.2077 23.542L11.666 20.0003L15.1868 16.4795L16.3743 17.667L14.8743 19.167H19.166V14.8753L17.6452 16.3962L16.4577 15.2087L19.9993 11.667L23.541 15.2087L22.3535 16.3962L20.8327 14.8753V19.167H25.1035L23.5827 17.667L24.791 16.4587L28.3327 20.0003L24.791 23.542L23.6035 22.3545L25.1243 20.8337H20.8327V25.1045L22.3327 23.5837L23.541 24.792L19.9993 28.3337Z" fill="#232426" fill-opacity="0.6"/>
</svg>`,
);
